var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLadderSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD61"
    },
    points: "467.633,501.801 289.194,94.788 270.207,138.096 429.659,501.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD61"
    },
    points: "326.278,10.199 288.305,10.199 72.78,501.801 110.754,501.801  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#534741"
    },
    d: "M476.974,497.705l-148.057-337.71h8.54c5.633,0,10.199-4.567,10.199-10.199 s-4.566-10.199-10.199-10.199h-17.482L300.33,94.788l35.289-80.493c1.382-3.155,1.08-6.793-0.804-9.675 C332.932,1.738,329.721,0,326.278,0h-37.973c-4.049,0-7.715,2.396-9.341,6.103l-58.525,133.493h-41.443 c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h32.501l-17.439,39.777h-41.58 c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h32.636l-17.439,39.777H124.94 c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h33.793l-17.439,39.777H98.422 c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h33.929l-17.439,39.777H70.884 c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h35.085l-17.439,39.777H44.366 c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h35.222l-16.148,36.833 c-1.382,3.155-1.08,6.793,0.804,9.675c1.884,2.882,5.094,4.619,8.538,4.619h37.974c4.049,0,7.715-2.396,9.341-6.103 l150.112-342.397L420.32,505.896c1.626,3.708,5.291,6.103,9.341,6.103h37.972c3.443,0,6.654-1.737,8.538-4.619 C478.054,504.497,478.356,500.859,476.974,497.705z M104.089,491.602H88.389L294.97,20.398h15.701L104.089,491.602z  M289.194,120.19l162.831,371.411h-15.701L281.343,138.096L289.194,120.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#534741"
    },
    d: "M364.995,159.995h1.666c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199h-1.666 c-5.633,0-10.199,4.567-10.199,10.199S359.362,159.995,364.995,159.995z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadderSvgrepoCom);
export default __webpack_public_path__ + "static/media/ladder-svgrepo-com.c66bf3076218820e9fdcf0ecaabb6c5d.svg";
export { ForwardRef as ReactComponent };